module.exports = __webpack_public_path__ + "img/norway-tuberculosis-female.8cb1038c.png";